import React, { useState, useEffect, useRef } from "react";
import Button from "../components/common/Button.js";
import * as Icons from "react-icons/tb";
import Checkbox from "../components/common/Checkbox.js";
import firebase from "../api/firebase.js";
import Modal from "../components/common/Modal.js";

const ShareText = ({ title, link }) => {
  const base_url = "https://sharepad.netlify.app";
  const [isModalOpen, setIsModalOpen] = useState(false);

  const currentUrl = window.location.href;
  const [data, setData] = useState([]);
  const firestore = firebase.firestore();
  const matchedDataIndex = data.findIndex(
    (element) => base_url + element.link === currentUrl
  );
  const [text, setText] = useState("");
  const [titleState, setTitleState] = useState(title);
  const ref = useRef();
  const [isChecked, setIsChecked] = useState(false);
  useEffect(() => {
    setIsModalOpen(true);
  }, []);
  const closeModal = () => {
    setIsModalOpen(false);
  };
  useEffect(() => {
    const fetchData = async () => {
      const collectionRef = firestore.collection("sharepad");
      const snapshot = await collectionRef.get();

      const fetchedData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setData(fetchedData);
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (matchedDataIndex !== -1) {
      const matchedData = data[matchedDataIndex];
      setTitleState(matchedData.title);
      setText(matchedData.text);
      setIsChecked(matchedData.protect);
    }
  }, [matchedDataIndex, data]);

  const handleTextareaChange = (event) => {
    var valueOfText = event.target.value;
    setText(valueOfText);
    event.target.style.height = "auto";
    event.target.style.height = `${event.target.scrollHeight}px`;
  };

  const handleChangeTitle = (event) => {
    var titleValue = event.target.value;
    setTitleState(titleValue);
  };

  const handleText = async () => {
    try {
      if (matchedDataIndex !== -1) {
        // Update existing data
        const updatedData = [...data];
        updatedData[matchedDataIndex] = {
          ...updatedData[matchedDataIndex],
          title: titleState,
          text: text,
          protect: isChecked,
        };
        setData(updatedData);
        await firestore
          .collection("sharepad")
          .doc(data[matchedDataIndex].id)
          .update({
            title: titleState,
            text: text,
            protect: isChecked,
          });
      } else {
        // Add new data
        const newDocRef = await firestore.collection("sharepad").add({
          title: titleState,
          text: text,
          link: link,
          protect: isChecked,
        });
        setData([
          ...data,
          {
            id: newDocRef.id,
            title: titleState,
            text: text,
            link: link,
            protect: isChecked,
          },
        ]);
      }

      alert(`you're File ${titleState} is saved`);
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  const handleCopy = () => {
    const textToCopy =
      matchedDataIndex !== -1
        ? base_url + data[matchedDataIndex].link
        : base_url + link;
    const tempInput = document.createElement("input");
    tempInput.value = textToCopy;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);

    alert("Link copied:", textToCopy);
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  return (
    <section className="text_box">
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <h2>Warning ⚠️</h2>
        <p>If you have protected before saving, you can make edits after protection, but once saved after protection, no further edits will be allowed.</p>
      </Modal>
      <div className="container">
        <div className="text_box_main">
          <input
            className="file_title"
            value={titleState}
            readOnly={isChecked}
            onChange={handleChangeTitle}
          />
          <textarea
            className="file_text"
            value={text}
            readOnly={isChecked}
            onChange={handleTextareaChange}
            placeholder="Type something..."
          />
          <div className="features_file">
            {!isChecked ? (
              <div className="features_file_item">
                <Checkbox
                  label="Protection"
                  isChecked={isChecked}
                  onCheckboxChange={handleCheckboxChange}
                />
              </div>
            ) : (
              ""
            )}
            <div className="features_file_item" ref={ref} onClick={handleCopy}>
              <p className="link_file">
                {matchedDataIndex !== -1
                  ? base_url + data[matchedDataIndex].link
                  : base_url + link}
              </p>
              <Icons.TbClipboardCopy />
            </div>
            {!isChecked ? (
              <div className="features_file_item">
                <Button text="Save" onClick={handleText} />
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShareText;
